import React,{Component} from 'react';
import Nav from '../Navigation/nav.js';
import { Redirect, Route,Switch,useLocation } from "react-router-dom";
import About from '../browse/about.js';
import Resume from '../browse/resume.js';
import Project from '../browse/project.js';
import { motion, AnimatePresence } from "framer-motion";

const Main = ()=>{
   const location = useLocation();
    

        return(
           <div>

                <Nav />
               
             
             <AnimatePresence exitBeforeEnter >
                 <Switch location={location} key ={location.key}>
                 <Route    exact path="/">
                  <About />
              </Route>
              <Route   path="/resume">
                  <Resume />
              </Route>
              <Route   path="/project">
                  <Project />
              </Route>
              <Route>
                  <Redirect to="/" />
              </Route>
                 </Switch>
              
                </AnimatePresence>
            
         
               

               
             

           </div>
            
           
        )
    
}
export default Main;